import React, { FC, useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import ChatgptIcon from "@assets/images/chartgpt-icon.gif";
import { CloseCircleFilled, CloseCircleOutlined } from "@ant-design/icons";
import { getChatGPTUrl } from "@src/utils/constants";
import styles from "./ChatGpt.module.scss";
import useGlobalModel from "@src/model/globalModel";

const ChartGpt: FC = () => {
  const {
    user,
} = useGlobalModel()
  // const [isShowIframe, setIsShowIframe] = useState<boolean>(false);
  //机器人滑动
  let isDragging = false;
  const handleDrag = () => {
    isDragging = true;
  };
  const handleStop = () => {
    setTimeout(() => (isDragging = false), 0);
  };

  const handleClick = () => {
    if (isDragging) {
      return;
    }
    // setIsShowIframe(true);
    window.open(`${getChatGPTUrl()}?token=${user.token}&r=${Math.random()}`)
  };


  const [isHide, setIsHide] = useState(false)

  const [showPopup, setShowPopup] = useState(true)

  const getTime = () => {
    const h = new Date().getHours()
    // 4点到8点为早上好，8点到10点为上午好，10点到12点为中午好，12点到18点为下午好，18点到凌晨四点为晚上好
    if(h > 3 && h < 8){
      return "早上好"
    }else if(h > 7 && h < 10){
      return "上午好"
    }
    else if(h > 9 && h < 12){
      return "中午好"
    }else if(h > 11 && h < 18){
      return "下午好"
    }
    else if((h > 17 && h < 24) || h === 0 || (h > 0 && h < 4)) {
      return "晚上好"
    }
  }
  

  return (
    <>
	{/* <div style={{position:"fixed", left: 0, bottom: 0, zIndex:9999}} onClick={() => {setIsHide(!isHide)}}>1111</div> */}
      <div id="draggable" className={styles.draggableBox} onMouseOver={()=> {setIsHide(true)}} onMouseOut={() => {setIsHide(false)}}>
        <Draggable
          bounds={{
            right: 0,
            left: 0,
            bottom: 0,
          }}
          defaultPosition={{ x: 0, y: 0 }}
          onDrag={handleDrag}
          onStop={handleStop}
        >
		 <div className={styles.draggableIcons}>
			{/* <div className={ `${styles.openIcon} ${styles['animated-content']} ${isHide ?  styles['slide-in'] : styles['slide-out']}`} onClick={handleClick}> */}
			<div className={ `${styles.openIcon} ${styles['animated-content']} ${styles['slide-in']}`} >
        {
          showPopup &&  <div className={styles['popup']}>
          <div className={styles['popup-title']}>{getTime()}</div>
          <div className={styles['popup-info']}>我是云豪车服AI智能汽车人，旨在为您办公增添效率和乐趣，我可以帮您处理维修及办公遇到的问题，快来试试吧！</div>
          <CloseCircleFilled className={styles['popup-close']} style={{color: '#ccc'}} onClick={() => {setShowPopup(false)}}/>
        </div>
        }
       
				<div
        onClick={handleClick}
				className={styles.openIconImg}
				style={{
					// backgroundImage: `url(${ChatgptIcon})`,
					// backgroundImage: `url(${ChatgptIcon})`,
          // 7e9ebdc4eeb3ea6647424e6a798b50cb
				}}
				>
          <img src={ChatgptIcon} />
        </div>
				{/* <span className={styles.openIconFont}>云豪助手</span> */}
			</div>
			{/* <div className={`${styles.closeIcon} ${styles['animated-content']} ${!isHide ?  styles['slide-in'] : styles['slide-out']}`}></div> */}
		  </div>
        </Draggable>
      </div>
    </>
  );
};

export default ChartGpt;
